import React, { useState, useEffect } from 'react'
import { Tile, Form, FormGroup, Button, Select, SelectItem, InlineNotification, NotificationActionButton, Modal } from 'carbon-components-react'
import { useHistory } from 'react-router-dom'
import { sleep } from '../../utils/functions/tools/sleep'
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const ClientSettings = (pageData) => {

    // Variables for modals and toasts
    const [openDeleteClient, setOpenDeleteClient] = useState(false);
    const [error, setError] = useState(false);

    // Other Variables
    let [clientSettings, setClientSettings] = useState(null)
    const history = useHistory()


    useEffect(() => {
        getClientSettings()
        document.title = "Client Profile | WillowBMS"
    }, [pageData.profileId])

    // Populate fields
    useEffect(() => {
    }, [clientSettings])

    let getClientSettings = async () => {
        if (pageData.profileId === 'new') return

        let response = await fetch(`${API_URL}/client/settings/view/${pageData.profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            }
        })
        let data = await response.json()
        setClientSettings(data)
    }

    let editClientSettings = async (values) => {
        values.preventDefault()
        let response = await fetch(`${API_URL}/client/settings/manage/edit/${clientSettings.id}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
            body: JSON.stringify({
                'id': clientSettings.id,
                'currency': values.target.currency.value,
                'language': values.target.language.value,
                'type': values.target.type.value,
                'client': pageData.profileId
            })
        })

        if (response.status === 200) {
            pageData.getClientSettings()
            pageData.showToast("success", "Success", "Client settings changes have been saved.")
        } else {
            pageData.showToast("error", "Error", "Unable to save client settings changes.")
        }
    }

    let deleteClient = async () => {
        let response = await fetch(`${API_URL}/client/delete/${pageData.client?.id}`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            }
        })

        if (response.status === 200) {
            setError(false)
            setOpenDeleteClient(false)
            let successMessage = "Client #" + pageData.client?.id + " has been deleted. Please wait to be redirected."
            pageData.showToast("success", "Success", successMessage)
            await sleep(2000)
            history.push(`/clients/`)
        } else {
            setError(true)
        }
    }

    return (
        <>
            <Tile light={true} className="row">
                <h5 className="tile-title">Settings</h5>
                <Form onSubmit={editClientSettings}>
                    <FormGroup className="d-flex flex-w">
                        <div className="col-12 col-md-6 m-005">
                            <Select labelText="Account Type" name="type" id="type" defaultValue="Organization" required>
                                <SelectItem value="Organization" text="Organization" />
                                <SelectItem value="Private" text="Private" />
                                <SelectItem value="Non-Profit" text="Non-Profit" />
                            </Select>
                        </div>
                        <div className="col-12 col-md-6 m-005">
                            <Select labelText="Customer Currency" name="currency" id="currency" defaultValue="CAD" required>
                                {pageData.currencies?.map((currency, index) => (
                                    <SelectItem key={index} value={currency.id} text={currency.currency + ' (' + currency.currencycode + ')'} />
                                ))}
                            </Select>
                        </div>
                        <div className="col-12 col-md-6 m-005">
                            <Select labelText="Language" name="language" id="language" defaultValue="English" required>
                                <SelectItem value="English" text="English" />
                                <SelectItem value="French" text="French" />
                            </Select>
                        </div>
                        <div className="col-12 m-005">
                            <Button type="submit">
                                Save Changes
                            </Button>
                        </div>
                    </FormGroup>
                </Form>
            </Tile>
            <Tile light={true} className="row">
                <h5>Delete Client</h5>
                <p className="mb-1 text-sm"><strong>Warning:</strong> Deleted data cannot be restored without a complete backup.</p>
                <div className="col-12">
                    <Button onClick={() => setOpenDeleteClient(true)} kind="danger">
                        Delete All Client Data
                    </Button>
                </div>
            </Tile>
            <Modal
                danger
                open={openDeleteClient}
                modalHeading={"Delete Client Data for #" + pageData.client.id + " - " + pageData.client.company}
                modalLabel="Client Settings"
                primaryButtonText="Delete Client"
                secondaryButtonText="Cancel"
                onRequestClose={() => setOpenDeleteClient(false) & setError(false)}
                onRequestSubmit={() => deleteClient() & setError(false)}
            >
                {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to delete client" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                <p>Are you sure you want to delete client #{pageData.client.id} - {pageData.client.company} and all of the data associated with them?</p>
                <p><strong>This cannot be reversed without a proper backup!</strong></p>
            </Modal>
        </>
    )
}

export default ClientSettings